import { Input, useIntl } from 'platform-components';
import { INPUT_SIZES, INPUT_THEMES } from 'platform-components/constants';
import React from 'react';

import { FullNameData } from 'common.components/certificate-modal/typings';

interface Props {
    canChangeData: boolean;
    fullNameData: FullNameData;
}

export const CertificateModalFullName = ({
    fullNameData: { fullName, fullNameErrorMessage, handleFullNameChange, handleValidateFullName },
    canChangeData,
}: Props) => {
    const intl = useIntl();

    return (
        <Input
            disabled={!canChangeData}
            errorMessage={fullNameErrorMessage}
            focused={true}
            mix="certificate-modal__form-field"
            onBlur={handleValidateFullName}
            onChange={handleFullNameChange}
            placeholder={intl.formatMessage({ id: 'certificatesModal.form.fio' })}
            size={INPUT_SIZES.XL}
            theme={INPUT_THEMES.YANDEX}
            valid={fullNameErrorMessage ? 'no' : 'uncertain'}
            value={fullName}
        />
    );
};
